import React from "react";
import { values as V } from "ramda";
import { Form, Row, Col, Input, Button, Icon, Select } from "antd";
import I18n from "../../i18n";
const Option = Select.Option;
const FormItem = Form.Item;

class SearchEmployeesForm extends React.Component {
    state = {
    	expand: false,
    };

    handleSearch = (e) => {
    	e.preventDefault();
    	const { onSubmitSearch } = this.props;
    	this.props.form.validateFields((err, values) => {
    		const search = { page: 0 };
    		Object.keys(values).map(key => {
    			if (values[key]) search[key] = values[key];
    		});
    		if (Object.keys(search).length > 1) onSubmitSearch(search);
    	});
    }

    handleReset = () => {
    	this.props.form.resetFields();
    	const { onSubmitSearch } = this.props;
    	onSubmitSearch();
    	// onSubmitSearch(employees)
    }

    toggle = () => {
    	const { expand } = this.state;
    	this.setState({ expand: !expand });
    }

    getFields() {
    	const { expand } = this.state;
    	const { category_title, form: { getFieldDecorator }, choice } = this.props;
    	const children = [];
    	Object.keys(category_title).map((key, index) => {
    		if (category_title[key] && expand) {
    			return children.push(
    				<Col key={index}>
    					<FormItem label={category_title[key]} style={{ marginBottom: 0 }}
    						labelCol={{ span: 8 }} wrapperCol={{ span: 8 }}>
    						{getFieldDecorator(`category${index + 1}`, { initialValue: "" })
    						(
    							<Select placeholder={`Search ${category_title[key]}`}>
    								<Option value=''>{I18n.t("all")}</Option>
    								{
    									choice[`choice${index + 1}`] && choice[`choice${index + 1}`].data && choice[`choice${index + 1}`]
    										.data.map((value, index) => {
    											return <Option key={index} value={value.id}>{value.name}</Option>;
    										})
    								}
    							</Select>
    						)
    						}
    					</FormItem>
    				</Col>
    			);
    		}
    	});
    	return children;
    }

    render() {
    	const { showCategory = true, form: { getFieldDecorator }, disableSearchEmail } = this.props;
    	return (
    		<Form style={{ marginBottom: 10 }} onSubmit={this.handleSearch} >
    			<Row gutter={24}>
    				<Col span={12}>
    					{
    						!disableSearchEmail &&
                            <FormItem label='E-mail' style={{ marginBottom: 0, }}
                            	labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
                            	{getFieldDecorator("search")(
                            		<Input placeholder='Search E-mail' />)}
                            </FormItem>
    					}
    				</Col>
    				<Col span={12} style={{ textAlign: "right", lineHeight: 2.5 }}>
    					<Button type="primary" htmlType="submit">Search</Button>
    					<Button style={{ marginLeft: 8 }} onClick={this.handleReset}>
    						{I18n.t("clear")}
    					</Button>
    					{showCategory ? <a style={{ marginLeft: 8, fontSize: 12 }} onClick={this.toggle}>
    						{I18n.t("collapse")} <Icon type={this.state.expand ? "up" : "down"} />
    					</a> : undefined}
    				</Col>
    			</Row>
    			{showCategory ? <Row gutter={24}>
    				{this.getFields()}
    			</Row> : undefined}
    		</Form>
    	);
    }
}
const WrappedSearchEmployeesForm = Form.create()(SearchEmployeesForm);
export default WrappedSearchEmployeesForm;


// WEBPACK FOOTER //
// ./src/components/form/SearchEmployeesForm.js